/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const brandSX: SxProps = () => ({
	fontWeight: OpenSansFontWeights.bold,
	'& a': {
		fontWeight: OpenSansFontWeights.bold,
	},
	marginBottom: '5px',
	textTransform: 'capitalize',
});
